import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=76bb939c&scoped=true"
import script from "./Matches.vue?vue&type=script&lang=js"
export * from "./Matches.vue?vue&type=script&lang=js"
import style0 from "./Matches.vue?vue&type=style&index=0&id=76bb939c&prod&lang=css"
import style1 from "./Matches.vue?vue&type=style&index=1&id=76bb939c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb939c",
  null
  
)

export default component.exports